import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext.js";
import "./styles/AdminEdit.css";

const AdminEdit = () => {
  const { id } = useParams();
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();

  const [userData, setUserData] = useState({
    username: "",
    display_name: "",
    email: "",
    role: "",
    password: ""
  });

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const resp = await fetch(`/api/admin/users/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (!resp.ok) throw new Error(`Status ${resp.status}`);
        const data = await resp.json();
        setUserData({
          username: data.username,
          display_name: data.display_name || "",
          email: data.email || "",
          role: data.role,
          password: ""
        });
      } catch (err) {
        setError("Could not load user data");
      }
    };
    fetchUser();
  }, [id, token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const resp = await fetch(`/api/admin/users/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(userData)
      });
      if (!resp.ok) {
        const err = await resp.json();
        throw new Error(err.message || "Update failed");
      }
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-layout">
      <div className="admin-layout-inner">
        <div className="admin-page-header">
          <h1>Edit User</h1>
          <p>Modify account details for user #{id}</p>
        </div>

        {error && <div className="admin-alert admin-alert-error">{error}</div>}

        <div className="admin-card">
          <div className="admin-card-body">
            <form className="admin-form" onSubmit={handleSubmit}>
              <div className="admin-form-group">
                <label className="admin-form-label">Username</label>
                <input className="admin-input" name="username" value={userData.username} onChange={handleChange} required />
              </div>

              <div className="admin-form-group">
                <label className="admin-form-label">Display Name</label>
                <input className="admin-input" name="display_name" value={userData.display_name} onChange={handleChange} placeholder="Name shown on articles" />
              </div>

              <div className="admin-form-group">
                <label className="admin-form-label">Email</label>
                <input className="admin-input" name="email" value={userData.email} onChange={handleChange} type="email" placeholder="user@example.com" />
              </div>

              <div className="admin-form-group">
                <label className="admin-form-label">New Password</label>
                <input className="admin-input" name="password" type="password" value={userData.password} onChange={handleChange} placeholder="Leave empty to keep current" />
                <div className="admin-form-hint">Only fill this if you want to change the password</div>
              </div>

              <div className="admin-form-group">
                <label className="admin-form-label">Role</label>
                <select className="admin-input" name="role" value={userData.role} onChange={handleChange} required>
                  <option value="admin">Admin</option>
                  <option value="journalist">Journalist</option>
                  <option value="reporter">Reporter</option>
                  <option value="user">Subscriber</option>
                  <option value="freemium">Freemium</option>
                </select>
              </div>

              <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
                <button type="submit" className="admin-btn admin-btn-primary" disabled={loading}>
                  {loading ? "Saving..." : "Save Changes"}
                </button>
                <button type="button" className="admin-btn admin-btn-ghost" onClick={() => navigate("/admin/dashboard")}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminEdit;
